import {observer} from "mobx-react";
import {useEffect, useState} from "react"
import {useStores} from "../../../../hooks";
import styles from "./style.module.sass"
import {
    ChosenMenuItemModifierChooseMany,
    ChosenMenuItemModifierSet,
    MenuItemModifierSet
} from "../../../../types/types";
import {MinusButton, PlusButton, PrimaryButton} from "../../../../components/buttons/plusButton";
import {
    MediaType, MenuItem,
    MenuItemModifierSetChooseManyData,
    MenuItemsPhotosModes,
    ModifiersSetType
} from "../../../../services/menu/models";
import {Trans, useTranslation} from "react-i18next";
import PlusMinusWidgetModifiers from "../../../../components/plusMinusWidget/PlusMinusWidgetModifiers";
import chevronDown from "./downChevron.png"
import useSwipeToDismiss from "../../../../hooks/useSwipeToDismiss";
import ItemBadges from "../../../../components/itemBadges";
import {resolveItemBadges} from "../../../../components/itemBadges/libs";
import LazyImage from "../../../../components/imageLazyLoader";
import SmallGreyText from "../../../../components/titles/SmallGreyTitle";


const hasAnyKBGUInfo = (item: MenuItem) => {
    return item.data.caloriesSettings.calories
        || item.data.caloriesSettings.fats
        || item.data.caloriesSettings.proteins
        || item.data.caloriesSettings.carbohydrates
}

const ModifiersModal = () => {
    const {menuStore, cartStore, generalMenuStore} = useStores();
    const item = menuStore.selectedPopupItem;
    const isOpen = generalMenuStore.isModifiersPopupVisible;
    const [chosen, setChosen] = useState<ChosenMenuItemModifierSet[]>([]);
    const [price, setPrice] = useState(0);
    const [counter, setCounter] = useState(1);
    const [isReady, setIsReady] = useState(false);
    const {t, i18n} = useTranslation(['general', 'menu', 'catalog']);
    const [isDisabledButtonClick, setIsDisabledButtonClick] = useState<boolean>(false);
    const [mandatoryChosenModifier, setMandatoryChosenModifier] = useState<string[]>([]);

    const buttonsColor = menuStore.menu?.data?.themeSettings?.buttonsBackgroundColor || '#FF2C3D'
    const isCartEnabled = menuStore.menu?.data?.isCartEnabled

    const {sheetRef, scrollRef, offset, opacity, horizontalOffset, isDragging} = useSwipeToDismiss({
        isOpen,
        onDismiss: () => {
            generalMenuStore.onOverlayClick && generalMenuStore.onOverlayClick();
        }
    });


    useEffect(() => {
        setIsDisabledButtonClick(false);
        setMandatoryChosenModifier([])
    }, [isOpen])

    const locale = i18n.language;

    useEffect(() => {
        if (!item) return;
        setPrice(item.data.sellPrice.price);
        setChosen(item.data.menuItemModifierSets.map(item => {
            return {
                menuItemModifierSetId: item.menuItemModifierSetId,
                chosenMenuItemModifiers: []
            }
        }));
        setCounter(1);
        setIsReady(true);

        return () => {
            setIsReady(false)
        }
    }, [item]);

    if (!isOpen) {
        return null
    }

    const classes = [styles.modalWindow];
    if (isOpen) {
        classes.push(styles.open);
    }


    if (!item || !isReady) {
        return <div className={classes.join(" ")}/>
    }

    const addToCart = () => {
        cartStore.addItem(item, chosen, counter);
        generalMenuStore.onOverlayClick && generalMenuStore.onOverlayClick();
    };

    const modifierMessage = () => {
        return setIsDisabledButtonClick(true);
    };


    const isChosen = (index: number, itemId: string) => {
        if (chosen.length === 0 || index > chosen.length + 1) return false;
        const item = chosen[index].chosenMenuItemModifiers.find(item => item.menuItemModifierId === itemId);

        return !!item;
    };

    const setChooseOne = (index: number, itemId: string) => {
        let newChosen = [...chosen];
        let selected = newChosen[index].chosenMenuItemModifiers;
        const modifierSet = menuStore.getModifiersById(newChosen[index].menuItemModifierSetId);
        let newPrice = price;
        const newItem = modifierSet.data.modifiers.find(item => item.id === itemId);
        if (!newItem) return;

        if (selected.length > 0 && selected[0].menuItemModifierId === itemId) {
            const item = modifierSet.data.modifiers.find(item => item.id === selected[0].menuItemModifierId);
            if (!item) return;
            newPrice -= item.data.sellPrice.price;
            newChosen[index].chosenMenuItemModifiers = []
            setChosen(newChosen);
            setPrice(newPrice);
        } else if (modifierSet.data.type === ModifiersSetType.ChooseOne && selected.length === 0) {
            newPrice += newItem.data.sellPrice.price;

            newChosen[index].chosenMenuItemModifiers = [{
                menuItemModifierId: itemId,
                count: 1
            }];
            setChosen(newChosen);
            setPrice(newPrice);
        } else {
            const modifier = modifierSet.data.modifiers.find((t) => t.id === selected[0].menuItemModifierId);
            if (!modifier) return;
            newPrice -= modifier.data.sellPrice.price;
            newPrice += newItem.data.sellPrice.price;

            newChosen[index].chosenMenuItemModifiers = [{
                menuItemModifierId: itemId,
                count: 1
            }];
            setChosen(newChosen);
            setPrice(newPrice);
        }
    };

    const getChooseManyFunctions = (index: number, itemId: string) => {
        let newChosen = [...chosen];
        let itemIndex = newChosen[index].chosenMenuItemModifiers.findIndex(item => item.menuItemModifierId === itemId);
        let newPrice = price;
        const modifierSet = menuStore.getModifiersById(newChosen[index].menuItemModifierSetId);
        const data = modifierSet.data as MenuItemModifierSetChooseManyData;
        const maxCount = data.maxCountTotalChosen;
        const amountOfAllChosenMenuItemModifiers = (index: number) => {
            let res = 0;
            const modifiers = chosen[index].chosenMenuItemModifiers;
            for (let i = 0; i < modifiers.length; i++) {
                res += modifiers[i].count
            }
            return res
        };


        let add;
        let remove;

        if (itemIndex >= 0) {
            const t = newChosen[index].chosenMenuItemModifiers[itemIndex] as ChosenMenuItemModifierChooseMany;
            add = () => {
                if (maxCount !== undefined && maxCount > 0 && chosen[index].chosenMenuItemModifiers.length >= maxCount) {
                    return;
                }

                if (amountOfAllChosenMenuItemModifiers(index) >= maxCount && maxCount !== 0) {
                    return;
                }

                t.count++;
                const newItem = modifierSet.data.modifiers.find(item => item.id === itemId);
                if (!newItem) return;
                newPrice += newItem.data.sellPrice.price;
                setPrice(newPrice);
                setChosen(newChosen);
            }
            remove = () => {
                if (t.count > 1) {
                    t.count--;
                    const newItem = modifierSet.data.modifiers.find(item => item.id === itemId);
                    if (!newItem) return;
                    newPrice -= newItem.data.sellPrice.price;
                } else {
                    let deleted = newChosen[index].chosenMenuItemModifiers.splice(itemIndex, 1);
                    const item = modifierSet.data.modifiers.find(item => item.id === deleted[0].menuItemModifierId);
                    if (!item) return;
                    newPrice -= item.data.sellPrice.price;

                }
                setPrice(newPrice);
                setChosen(newChosen);
            }

        } else {
            add = () => {
                if (maxCount !== undefined && maxCount > 0 && chosen[index].chosenMenuItemModifiers.length >= maxCount) {
                    return;
                }
                if (amountOfAllChosenMenuItemModifiers(index) >= maxCount && maxCount !== 0) {
                    return;
                }
                const newItem = modifierSet.data.modifiers.find(item => item.id === itemId);
                if (!newItem) return;
                newPrice += newItem.data.sellPrice.price;

                newChosen[index].chosenMenuItemModifiers.push({
                    menuItemModifierId: itemId,
                    count: 1
                });
                setPrice(newPrice);
                setChosen(newChosen);
            }
            remove = () => {
            }
        }

        return {add, remove};

    };

    const renderChooseMany = (set: MenuItemModifierSet, index: number) => {
        const data = set.data as MenuItemModifierSetChooseManyData;
        const maxCount = data.maxCountTotalChosen;
        const minCount = data.minCountTotalChosen;

        return <div key={set.id} className={styles.modifierSetBox}>
            <p className={styles.modifierSetTitle}>{set.data.name[locale]}</p>
            {maxCount > 0 && minCount === 0 && <p className={styles.modifierSetChooseManyMaxCountHint}>
                <Trans i18nKey="menu:modifiers.chooseManyNoMore" values={{maxCount}}>
                    Выберите не более {{maxCount}}
                </Trans>
            </p>}
            {minCount > 0 && maxCount === 0 && <p className={styles.modifierSetChooseManyMaxCountHint}>
                <Trans i18nKey="menu:modifiers.chooseManyNoLess" values={{minCount}}>
                    Выберите не менее {{minCount}}
                </Trans>
            </p>}
            {minCount > 0 && maxCount > 0 && <p className={styles.modifierSetChooseManyMaxCountHint}>
                <Trans i18nKey="menu:modifiers.chooseManyBetween" values={{maxCount, minCount}}>
                    Выберите от {{minCount}} до {{maxCount}}
                </Trans>
            </p>}
            <div className={styles.modifierSetSpace}/>

            {set.data.modifiers
                .filter(item => !item.data.isInStopList)
                .map((item) => {
                    const {add, remove} = getChooseManyFunctions(index, item.id);
                    let count = 0;
                    const selectedModifier = chosen[index].chosenMenuItemModifiers.find(d => d.menuItemModifierId === item.id) as ChosenMenuItemModifierChooseMany;

                    if (selectedModifier) {
                        count = selectedModifier.count;
                    }
                    return <div key={item.id} className={styles.checkboxButtonGroup}
                    >
                        <label
                            htmlFor={`${item.id}_${index}`}
                            className={styles.checkboxLabel}
                        >
                            {item.data.name[locale]}
                            <span
                                className={styles.addPrice}>+{(item.data.sellPrice.price / 100).toFixed()} {t("general:currency.rub")}</span>
                        </label>
                        <PlusMinusWidgetModifiers
                            count={count}
                            add={add}
                            remove={remove}
                        />
                    </div>
                })}
        </div>
    };

    const renderChooseOne = (set: MenuItemModifierSet, index: number) => {

        const modifierArray = set.data.modifiers.map(item => item.id);
        const isModifierChosen = () => {
            let result: boolean = false;
            if (mandatoryChosenModifier.length === 0) result = false;
            for (let n = 0; n < mandatoryChosenModifier.length; n++) {
                if (modifierArray.includes(mandatoryChosenModifier[n])) {
                    result = true;
                    break;
                }
            }
            return result;
        }

        return <div key={set.id} className={styles.modifierSetBox}>
            <p className={styles.modifierSetTitle}>{set.data.name[locale]}</p>
            {
                set.data.type === ModifiersSetType.ChooseOne && set.data.isRequired &&
                <>
                    {(isDisabledButtonClick && !isModifierChosen()) ? <>
                            <p className={styles.modifierSetChooseManyMaxCountHint + " " + styles.modifierMsg}>
                                <Trans i18nKey="menu:modifiers.chooseOneIsRequired">
                                    Обязательная опция - необходимо выбрать один из вариантов
                                </Trans>
                            </p>
                        </>
                        :
                        <p className={styles.modifierSetChooseManyMaxCountHint}>
                            <Trans i18nKey="menu:modifiers.chooseOneIsRequired">
                                Обязательная опция - необходимо выбрать один из вариантов
                            </Trans>
                        </p>
                    }
                </>

            }
            {set.data.modifiers
                .filter(item => !item.data.isInStopList)
                .map((item) => {
                    return <div key={item.id} className={styles.radioButtonGroup}>
                        <input
                            type={'radio'}
                            checked={isChosen(index, item.id)}
                            value={item.id}
                            className={styles.radioInput}
                            id={`${item.id}_${index}`}
                            onChange={() => {
                                setChooseOne(index, item.id);
                                if (isModifierChosen()) setIsDisabledButtonClick(false);
                                mandatoryChosenModifier.push(item.id)
                            }}
                        />
                        <label
                            htmlFor={`${item.id}_${index}`}
                            className={styles.radioLabel}
                        >
                            {item.data.name[locale]}
                            <span
                                className={styles.addPrice}>+{(item.data.sellPrice.price / 100).toFixed()} {t("general:currency.rub")}</span>
                        </label>
                    </div>
                })}
        </div>
    };

    const isOkToAdd = () => {
        let ok = true;
        item.data.menuItemModifierSets.forEach((setDescriptor, index) => {
            const set = menuStore.getModifiersById(setDescriptor.menuItemModifierSetId);
            if (!set) return null;
            const t = chosen[index];
            if (set.data.type === ModifiersSetType.ChooseOne) {
                if (set.data.isRequired && t.chosenMenuItemModifiers.length === 0) {
                    ok = false;
                }
            } else if (set.data.type === ModifiersSetType.ChooseMany) {
                const maxCount = set.data.maxCountTotalChosen;
                const minCount = set.data.minCountTotalChosen;
                const count = t.chosenMenuItemModifiers.reduce((memo, d) => {
                    return memo + (d as ChosenMenuItemModifierChooseMany).count;
                }, 0)

                if (count < minCount || (maxCount > 0 && count > maxCount)) {
                    ok = false;
                }
            }
        })
        return ok;
    }

    const calculatePrice = (priceToCalc: number, counterToCalc: number) => {
        return `${(priceToCalc * counterToCalc / 100).toFixed(priceToCalc % 100 > 0 ? 2 : 0)}`
    }

    const badges = resolveItemBadges(item, menuStore.badgesById);

    const windowWidth = document.documentElement.offsetWidth;
    const baseTopOffset = windowWidth > 700 ? 30 : 0;

    return <div className={classes.join(" ")}
                ref={sheetRef}
                style={{
                    transform: `translateY(${baseTopOffset + offset}px)`,
                    opacity,
                    left: horizontalOffset,
                    right: horizontalOffset,
                    bottom: windowWidth > 700 ? 20 : 0,
                    transition: isDragging ? 'none' : undefined,
                }}
    >
        <div ref={scrollRef}
             style={{
                 overflowY: 'scroll',
                 height: '100%',
                 paddingBottom: 120,
                 boxSizing: 'border-box',
                 // Доскролл внутри карточки не уходит в страницу под ней (и не тянет pull-to-refresh).
                 overscrollBehavior: 'contain'
             }}>
            {
                menuStore.menu.data.themeSettings.storefrontPhotosMode === MenuItemsPhotosModes.defaultWithPhotos
                && <div className={styles.mainImg}>
                    <LazyImage media={item.data.media} height={'100%'} asCarousel={true} type={MediaType.regular}
                               playable={true}
                    />
                </div>
            }

            <div className={styles.container}>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    {item.data.supplierLogoUrl && (
                        <img style={{maxHeight: 50, maxWidth: 50, borderRadius: 10, marginRight: 10}}
                             src={`${item.data.supplierLogoUrl}`} alt=""/>
                    )}
                    <ItemBadges badges={badges.all}/>
                </div>
                <div className={styles.nameAndWeight}>
                    <p className={styles.title}>{item.data.name[locale]}</p>
                    {item.data.weightSettings.value && item.data.weightSettings.measurement &&
                        <SmallGreyText>
                            <p>{item.data.weightSettings.value + " " + item.data.weightSettings.measurement}</p>
                        </SmallGreyText>
                    }
                </div>
                <p className={styles.description}>
                    {item.data.description[locale]}
                </p>
                {hasAnyKBGUInfo(item) && <div className={styles.kkal}>
                    <p>{t("catalog:kbzhu") || '-'}</p>
                    <div>
                        <p>{t("catalog:k")}</p>
                        <span>{item.data.caloriesSettings.calories || '-'}</span>
                    </div>
                    <div>
                        <p>{t("catalog:b")}</p>
                        <span>{item.data.caloriesSettings.proteins || '-'}</span>
                    </div>
                    <div>
                        <p>{t("catalog:zh")}</p>
                        <span>{item.data.caloriesSettings.fats || '-'}</span>
                    </div>
                    <div>
                        <p>{t("catalog:u")}</p>
                        <span>{item.data.caloriesSettings.carbohydrates || '-'}</span>
                    </div>
                </div>
                }
                {item.data.menuItemModifierSets.map((setDescriptor, index) => {
                    const set = menuStore.getModifiersById(setDescriptor.menuItemModifierSetId);
                    if (!set) return null;
                    if (set.data.type === ModifiersSetType.ChooseMany) {
                        return renderChooseMany(set, index)
                    } else if (set.data.type === ModifiersSetType.ChooseOne) {
                        return renderChooseOne(set, index);
                    }
                    return null;
                })}
            </div>

            <div className={styles.chevronDown} onClick={() => {
                generalMenuStore.onOverlayClick && generalMenuStore.onOverlayClick();
            }}>
                <img src={chevronDown} alt=""/>
            </div>
            <div className={styles.addToCartContainer}>
                <div className={styles.buttonsContainer}>
                    <div className={styles.plusMinusWidgetContainer}>
                        <MinusButton onClick={() => {
                            if (counter === 1) return;
                            setCounter(counter - 1)
                        }}/>
                        <span className={styles.counter}>{counter}</span>
                        <PlusButton onClick={() => {
                            setCounter(counter + 1)
                        }}/>
                    </div>
                    <div className={styles.addToCartButtonContainer}>
                        {
                            isCartEnabled ? (
                                <PrimaryButton
                                    background={buttonsColor}
                                    title={
                                        <Trans
                                            i18nKey='general:addMenuItem'
                                            values={{price: calculatePrice(price, counter)}}
                                        />
                                    }
                                    onClick={() => {
                                        if (isOkToAdd()) {
                                            addToCart()
                                        } else {
                                            modifierMessage();
                                        }
                                    }}
                                    disabled={!isOkToAdd()}
                                />
                            ) : (
                                <div
                                    style={{
                                        padding: '10px 15px',
                                        width: "100%",
                                        textAlign: "right",
                                        boxSizing: "border-box",
                                        fontWeight: 500,
                                        fontSize: "13pt"
                                    }}
                                >
                                    {calculatePrice(price, counter)} {t("general:currency.rub")}
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>

    </div>
};


export default observer(ModifiersModal);
